<template>
  <div class="content">
    <div class="inner_content">
      <div class="flex" style="margin-right: 30px">
        <div>通联平台的应用appid：</div>
        <el-input
          v-model="cus_appid"
          placeholder="请输入appid"
          class="flxedWidth"
        ></el-input>
      </div>
      <div class="flex" style="margin-right: 30px">
        <div>交易商户号：</div>
        <el-input
          v-model="cusid"
          placeholder="请输入交易商户号"
          class="flxedWidth"
        ></el-input>
      </div>
      <div class="flex" style="margin-right: 30px">
        <div>交易秘钥：</div>
        <el-input
          v-model="app_key"
          placeholder="请输入交易秘钥"
          class="flxedWidth"
        ></el-input>
      </div>
      <div class="bottom">
        <el-button type="plarmy" @click="setId">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { tongunionData, tongunionStatus } from "@/api/pay";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      cus_appid: "",
      cusid: "",
      app_key: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id
        // page: this.page,
      };
      tongunionData(data).then(res => {
        console.log("unionData222: ", res);
        if (res.code == 200) {
          this.cus_appid = res.data.cus_appid;
          this.cusid = res.data.cusid;
          this.app_key = res.data.app_key;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 设置
    setId() {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id,
        cus_appid: this.cus_appid,
        cusid: this.cusid,
        app_key: this.app_key
      };
      tongunionStatus(data).then(res => {
        console.log("设置数据", res);
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.reload();
        } else {
          this.$message(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  border: 1px solid #f1f1f1;
  overflow-y: auto;
  min-width: 900px;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 24px 24px 0;
    height: 100%;
    .zhifubao-top {
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0px;
}
.flxedWidth {
  width: 140px;
}
.color-red {
  color: red;
  padding-right: 10px;
}
.color-blue {
  color: #409eff;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
